import React, { Component } from 'react';
import logoDark from './logo.svg';
import logoBright from './logo_n.svg';
import './App.css';

class App extends Component {
  render() {
    const hr = (new Date()).getHours();
    const isNight = hr > 18 || hr < 6;
    const logoDynamic = isNight ? logoDark : logoBright;

    return (
      <div className="App-logo-container">
          <img src={logoDynamic} className="App-logo" alt="logo" />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js